class PopupForm {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.popupOpenEl = document.querySelectorAll('[popup-form-open]');
        this.popupCloseEl = this.root.querySelector('[popup-form-close]');
        this.popupInnerEl = this.root.querySelector('[popup-inner]');

        return true;
    }

    init() {
        this.setOpen();
        this.setClose();
        this.setClickOutside();
    }

    setOpen() {
        if (!this.popupOpenEl) return;

        this.onOpen = this.onOpenClick.bind(this);
        this.popupOpenEl.forEach(item => {
            item.addEventListener('click', this.onOpen);
        });
    }

    setClose() {
        if (!this.popupCloseEl) return;

        this.popupCloseEl.addEventListener('click', () => {
            this.close();
        });
    }

    setClickOutside() {
        this.onClickOutside = event => {
            const isOpen =
                this.root.classList.contains('opacity-100') &&
                this.root.classList.contains('pointer-events-auto');

            if (
                isOpen &&
                this.popupInnerEl &&
                !this.popupInnerEl.contains(event.target)
            ) {
                this.close();
            }
        };

        document.addEventListener('mousedown', this.onClickOutside);
    }

    close() {
        this.root.classList.add('opacity-0', 'pointer-events-none');
        this.root.classList.remove('opacity-100', 'pointer-events-auto');
    }

    onOpenClick(event) {
        event.stopPropagation();
        this.root.classList.remove('opacity-0', 'pointer-events-none');
        this.root.classList.add('opacity-100', 'pointer-events-auto');
    }
}

export default function initPopupForm() {
    const sections = document.querySelectorAll('[popup-form]');
    if (!sections) return;

    sections.forEach(el => {
        new PopupForm(el);
    });
}
